<template>
  <aside v-if="sessionKey && calls.length" class="incoming-call-notices" :aria-label="$t('megafon.incoming_call')" aria-live="polite">
    <v-card v-for="call in calls" :key="call.id" class="mb-3" elevation="6" data-testid="incoming-call-notice">
      <div class="d-flex align-center px-4 pt-2">
        <v-icon small color="primary" class="mr-2">mdi-phone-incoming</v-icon>
        <span class="text-subtitle-2">{{ $t('megafon.incoming_call') }}</span>
        <v-spacer />
        <v-btn icon :aria-label="$t('megafon.dismiss_call')" @click="dismiss(call.id)"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-card-text class="pt-0 pb-1">
        <div v-if="call.name" class="text-subtitle-1 font-weight-medium incoming-call-name">{{ call.name }}</div>
        <div class="text-body-1">{{ call.phone ? formatPhone(call.phone) : $t('megafon.hidden_number') }}</div>
      </v-card-text>
      <v-card-actions class="px-3 pb-3 flex-wrap">
        <v-btn v-if="call.client_id" small text color="primary" :to="`/clients/${call.client_id}`" @click="dismiss(call.id)">{{ $t('megafon.open_client') }}</v-btn>
        <v-btn v-if="call.lead_id" small text color="primary" :to="`/crm/leads/${call.lead_id}`" @click="dismiss(call.id)">{{ $t('megafon.open_lead') }}</v-btn>
      </v-card-actions>
    </v-card>
  </aside>
</template>

<script>
import { formatPhone } from '@/lib/phone/display';
export default {
  name: 'IncomingCallNotices',
  data: () => ({ timer: null }),
  computed: {
    isRussiaService() {
      const company = this.$store.getters.getCompany;
      return ['Russia', 'Россия'].includes(company && company.company && company.company.country);
    },
    sessionKey() {
      const getters = this.$store.getters;
      const user = getters.getCurrentUser || {};
      const company = getters.getCompany && getters.getCompany.company;
      return getters.getSignedIn && getters.isStaff && this.isRussiaService && user.active !== false &&
        !getters['deviceLock/locked'] && !getters['deviceLock/tabClosed'] && user.id && company && company.id && getters.getAuthToken
        ? `${user.id}:${company.id}:${getters.getAuthToken}` : '';
    },
    calls() { return this.$store.getters['incomingCalls/visible'] || []; },
  },
  watch: {
    sessionKey: { immediate: true, handler(value) {
      clearInterval(this.timer);
      this.$store.dispatch('incomingCalls/stop');
      if (!value) return;
      this.$store.dispatch('incomingCalls/start', { companyId: this.$store.getters.getCompany.company.id });
      this.timer = setInterval(() => this.$store.commit('incomingCalls/TICK', Date.now()), 1000);
    } },
  },
  beforeDestroy() { clearInterval(this.timer); this.$store.dispatch('incomingCalls/stop'); },
  methods: { formatPhone, dismiss(id) { this.$store.dispatch('incomingCalls/dismiss', id); } },
};
</script>

<style scoped>
.incoming-call-notices { position: fixed; top: 80px; right: 16px; width: min(360px, calc(100vw - 32px)); z-index: 205; pointer-events: none; }
.incoming-call-notices > * { pointer-events: auto; }
.incoming-call-name { overflow-wrap: anywhere; }
@media (max-width: 600px) { .incoming-call-notices { top: 68px; right: 8px; width: calc(100vw - 16px); } }
</style>
